import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../../shared/cardholders-core/services/auth.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { HomepageService } from '../../services/homepage.service';
import { BehaviorSubject } from 'rxjs';
import { GtmService } from "../../../../shared/cardholders-core/services/gtm.service";
import { IHomepageCards } from "../../models/homepage-cards";
import { IBackgroundDetails } from "../../models/homepage-background";

@Component({
    selector: 'app-choose-card',
    templateUrl: './choose-card.component.html',
    styleUrls: ['./choose-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ChooseCardComponent implements OnInit {
    isBrowser = false;
    cardCategories: any;
    sliderConfig: any;
    show: boolean;
    loaded = false;
    isLoaded: BehaviorSubject<boolean>;
    backgroundDetails: IBackgroundDetails;

    constructor(
        private authSvc: AuthService,
        private uiHelper: UiHelperService,
        private homepageService: HomepageService,
        private gtmService: GtmService
    ) {
        this.cardCategories = undefined;
    }

    ngOnInit(): void {
        this.isLoaded = new BehaviorSubject<boolean>(false);
        this.show = !this.authSvc.isUserAuthenticated();
        this.isBrowser = this.uiHelper.isBrowser;
        this.homepageService.loadCardCategories().then((res: IHomepageCards) => {
            this.cardCategories = res.CardCategoryResult;
            this.backgroundDetails = res.Background;
            if (this.uiHelper.isBrowser) {
                this.updateLoadStatus(true);
            }
        });

        if (this.isBrowser) {
            this.sliderConfig = {
                dots: false,
                infinite: false,
                centerMode: false,
                slidesToShow: this.uiHelper.IsMobile(576) ? 2 : 5,
                slidesToScroll: 1,
                speed: 300,
                arrows: true,
                rtl: true,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            arrows: false,
                            variableWidth: true,
                            variableHeight: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            waitForAnimate: false
                        }
                    }
                ]
            };
        }
        }

        updateLoadStatus(loadStatus: boolean): void {
            this.isLoaded.next(loadStatus);
        }

    registrationToGtm(event: any) {
        try {
            event.slick.$nextArrow[0].onclick = () => {
                this.gtmService.pushDirective({ category: 'New website - anonymous', action: 'Click on card arrow', label: 'Left' });
            }

            event.slick.$prevArrow[0].onclick = () => {
                this.gtmService.pushDirective({ category: 'New website - anonymous', action: 'Click on card arrow', label: 'Right' });
            }
        } catch (error) { }
    }

    swipeToGtm(event: any) {
        this.swipePush(event.currentSlide < event.nextSlide ? 'Left' : 'Right');
    }

    swipePush(direction: string) {
        this.gtmService.pushDirective({ category: 'New website - anonymous', action: 'Swipe cards', label: direction });
    }
}